import {
  requestFeeds,
  receiveFeeds,
  rejectFeeds
} from './actions'

export {
  requestFeeds,
  receiveFeeds,
  rejectFeeds,
  // thunks
  fetchFeeds
}

// Thunks
function fetchFeeds(endpoint, name, homepage){
  return dispatch =>{
    dispatch(requestFeeds(name));
    let rssToJSONEndpoint = `https://api.rss2json.com/v1/api.json?rss_url=${endpoint}`;
    
    return fetch(rssToJSONEndpoint).then(
        response => response.json(),
        err => dispatch(rejectFeeds(err,name))
      )
      .then(json=>dispatch(receiveFeeds(json.items, name, homepage)))
  }
}